// extracted by mini-css-extract-plugin
export default {"r_l":"a1631d7c68 f74a2af42d","t":"_92290ccc93"};